/* eslint-disable no-unused-vars */
import { AutoComplete, Input } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IoLocationSharp } from 'react-icons/io5';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import { ILocationMap } from '../../interfaces/map.interface';

interface SearchLocationProps {
    updateLocation: (location: ILocationMap) => void;
    setDefaultLocation: () => void;
}

const { Search } = Input;

const DEFAULT_ZOOM = 15;

const SearchLocation: FC<SearchLocationProps> = ({ updateLocation, setDefaultLocation }) => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    const {
        suggestions: { data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        debounce: 300,
    });

    const handleSearch = (newValue: string) => {
        setValue(newValue);
    };

    const handleSelect = (description: string) => {
        setValue(description, false);
        clearSuggestions();

        getGeocode({ address: description }).then(async (results: any) => {
            const { lat, lng } = await getLatLng(results[0]);
            updateLocation({
                center: { lat, lng },
                zoom: DEFAULT_ZOOM,
            });
        });
    };

    const handleChange = (value: string) => {
        if (value === '') {
            setDefaultLocation();
        }
    };

    const searchResult = useMemo(() => data.map((place: any) => ({
        value: place.description,
        label: (
            <div>
                <IoLocationSharp style={{ marginRight: 8 }} scale={10} />
                {place.description}
            </div>
        ),
    })), [data]);

    return (
        <AutoComplete
            options={searchResult}
            onSelect={handleSelect}
            style={{ width: '100%' }}
            defaultActiveFirstOption
            onSearch={handleSearch}
            onChange={handleChange}
        >
            <Search
                placeholder={t('SEARCH_LOCATION')}
                enterButton
                style={{ border: 'none' }}
            />
        </AutoComplete>
    );
};

export { SearchLocation };
